import React, { useState, useEffect, useCallback, Fragment } from "react";
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { makeStyles } from "@mui/styles";
import Typography from "@mui/material/Typography";
import LoginMenu from "../../../../components/LoginMenu/LoginMenu";
import { TextField, Grid, IconButton, Tooltip } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CommentCard from '../../../../components/CommentCard/CommentCard';
import CircularProgress from "@mui/material/CircularProgress";
import { format } from 'date-fns';
import BottomBar from "../../../../components/BottomBar/BottomBar";

const useStyles = makeStyles(() => ({
  root: {
    paddingBottom: '1%',
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 0
  },
  title: {
    color: "#1d5f98",
    fontWeight: 600,
    borderBottom: "1px solid rgb(58, 127, 187, 0.3)",
    width: "98%",
    marginBottom: 25,
    fontSize: 20,
    textTransform: 'capitalize'
  }
}));

const GradedDiscussionForm = (props) => {
  const { setDrawerOpen } = props;
  const { gdaId: gdaIdParam } = useParams();
  const classes = useStyles();

  const [gdaId, setGdaId] = useState(gdaIdParam);
  const [isLoading, setIsLoading] = useState(false);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [isReload, setIsReload] = useState(false);
  const [isLoginMenu, setIsLoginMenu] = useState(false);
  const [isOpenSnackbar, setIsOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("");
  const [gdaLabel, setGdaLabel] = useState("");
  const [gdaTotalMarks, setGdaTotalMarks] = useState("");
  const [gdaInstruction, setGdaInstruction] = useState("");
  const [gdaStartDate, setGdaStartDate] = useState(null);
  const [gdaDdueDate, setGdaDdueDate] = useState(null);
  const [gdaStartDateWithoutConversion, setGdaStartDateWithoutConversion] = useState(0);
  const [gdaDueDateWithoutConversion, setGdaDueDateWithoutConversion] = useState(0);
  const [courseLabel, setCourseLabel] = useState("");
  const [sectionLabel, setSectionLabel] = useState("");
  const [sectionId, setSectionId] = useState("");
  const [discussionEssay, setDiscussionEssay] = useState("");
  const [discussionEssayError, setDiscussionEssayError] = useState("");
  const [obtainedMarks, setObtainedMarks] = useState("");
  const [commentsData, setCommentsData] = useState([]);
  const [commentLoading, setCommentLoading] = useState(false);
  const [isUploaded, setIsUploaded] = useState(0);

  const handleOpenSnackbar = useCallback((msg, severity) => {
    setIsOpenSnackbar(true);
    setSnackbarMessage(msg);
    setSnackbarSeverity(severity);
  }, []);

  const handleCloseSnackbar = useCallback((event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setIsOpenSnackbar(false);
  }, []);

  const loadData = useCallback(async (gdaIdParam) => {
    const data = new FormData();
    data.append("gdaId", gdaIdParam);
    setIsLoading(true);
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/lms/C106CommonAcademicsGradedDiscussionsBoardStudentsView`;
    await fetch(url, {
      method: "POST",
      body: data,
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("lmsToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          if (json.CODE === 1) {
            if (json.DATA.length) {
              setSectionId(json.DATA[0].sectionId);
              setSectionLabel(json.DATA[0].sectionLabel);
              setGdaLabel(json.DATA[0].gdaLabel);
              setGdaStartDate(json.DATA[0].gdaStartDate);
              setGdaStartDateWithoutConversion(json.DATA[0].gdaStartDateWithoutConversion);
              setGdaDdueDate(json.DATA[0].gdaDueDate);
              setGdaDueDateWithoutConversion(json.DATA[0].gdaDueDateWithoutConversion);
              setGdaTotalMarks(json.DATA[0].gdaTotalMarks);
              setGdaInstruction(json.DATA[0].gdaInstruction);
              setDiscussionEssay(json.DATA[0].discussionEssay);
              setCourseLabel(json.DATA[0].courseLabel);
              setObtainedMarks(json.DATA[0].obtainedMarks);
              setIsUploaded(json.DATA[0].isUploaded);
            } else {
              window.location.replace(`#/dashboard/graded-discussion-reports`);
            }
          } else {
            handleOpenSnackbar(json.SYSTEM_MESSAGE + "\n" + json.USER_MESSAGE, "error");
            if (json.CODE == 3) {
              setTimeout(() => window.location.replace('#/dashboard/graded-discussion-reports'), 2000);
            }
          }
          console.log(json);
        },
        (error) => {
          if (error.status == 401) {
            setIsLoginMenu(true);
            setIsReload(false);
          } else {
            console.log(error);
            handleOpenSnackbar(
              "Failed to Save ! Please try Again later.",
              "error"
            );
          }
        }
      );
    setIsLoading(false);
  }, [handleOpenSnackbar]);

  const getCommentsData = useCallback(async (gdaIdParam) => {
    const data = new FormData();
    data.append("gdaId", gdaIdParam);
    setCommentLoading(true);
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/lms/C106CommonAcademicsGradedDiscussionsBoardStudentsViewAll`;
    await fetch(url, {
      method: "POST",
      body: data,
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("lmsToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          if (json.CODE === 1) {
            setCommentsData(json.DATA || []);
          }
          else {
            handleOpenSnackbar(json.SYSTEM_MESSAGE + "\n" + json.USER_MESSAGE, "error");
          }
          console.log(json);
        },
        (error) => {
          if (error.status == 401) {
            setIsLoginMenu(true);
            setIsReload(false);
          } else {
            console.log(error);
            handleOpenSnackbar(
              "Failed to load comments data ! Please try Again later.",
              "error"
            );
          }
        }
      );
    setCommentLoading(false);
  }, [handleOpenSnackbar]);

  const isFormValid = useCallback(() => {
    let isValid = true;
    let errorMsg = "";

    if (!discussionEssay) {
      errorMsg = "Please enter Discussion Essay";
      isValid = false;
    } else {
      errorMsg = "";
    }

    setDiscussionEssayError(errorMsg);

    return isValid;
  }, [discussionEssay]);

  const clickOnFormSubmit = useCallback(() => {
    if (isFormValid()) {
      document.getElementById("gradedDiscussionStudentSubmit").click();
    }
  }, [isFormValid]);

  const onFormSubmit = useCallback(async (e) => {
    e.preventDefault();
    const data = new FormData(e.target);
    setIsLoading(true);
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/lms/C106CommonAcademicsGradedDiscussionsBoardStudentsSave`;
    await fetch(url, {
      method: "POST",
      body: data,
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("lmsToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          if (json.CODE === 1) {
            handleOpenSnackbar(json.USER_MESSAGE, "success");
            setTimeout(() => window.location.replace('#/dashboard/graded-discussion-reports'), 1000);
          } else {
            handleOpenSnackbar(
              json.SYSTEM_MESSAGE + "\n" + json.USER_MESSAGE,
              "error"
            );
          }
          console.log(json);
        },
        (error) => {
          if (error.status == 401) {
            setIsLoginMenu(true);
            setIsReload(false);
          } else {
            console.log(error);
            handleOpenSnackbar(
              "Failed to Save ! Please try Again later.",
              "error"
            );
          }
        }
      );
    setIsLoading(false);
  }, [handleOpenSnackbar]);

  const viewReport = useCallback(() => {
    window.location = "#/dashboard/graded-discussion-reports";
  }, []);

  const handleDateChange = useCallback((name, date) => {
    if (name === 'gdaStartDate') {
      setGdaStartDate(date);
    } else if (name === 'gdaDdueDate') {
      setGdaDdueDate(date);
    }
  }, []);

  const onHandleChange = useCallback((e) => {
    const { name, value } = e.target;
    if (name === 'discussionEssay') {
      setDiscussionEssay(value);
      setDiscussionEssayError("");
    }
  }, []);

  useEffect(() => {
    setDrawerOpen(false);
    if (gdaId != 0) {
      loadData(gdaId);
      getCommentsData(gdaId);
    }
  }, []);

  useEffect(() => {
    const newGdaId = gdaIdParam;
    if (newGdaId !== gdaId) {
      if (newGdaId != 0) {
        setDrawerOpen(false);
        loadData(newGdaId);
        getCommentsData(newGdaId);
        setGdaId(newGdaId);
      } else {
        window.location.replace('#/dashboard/graded-discussion-reports');
      }
    }
  }, [gdaIdParam, gdaId, loadData, getCommentsData, setDrawerOpen]);

  const currenDate = format(new Date(), "MM-dd-yyyy");
  const dueCheck = new Date(gdaDueDateWithoutConversion).getTime() < new Date(currenDate).getTime() || isUploaded === 1
    || new Date(gdaStartDateWithoutConversion).getTime() > new Date(currenDate).getTime();

  return (
    <Fragment>
      <LoginMenu
        reload={isReload}
        open={isLoginMenu}
        handleClose={() => setIsLoginMenu(false)}
      />
      <form id="myForm" onSubmit={onFormSubmit}>
        <TextField
          type="hidden"
          name="gdaId"
          value={gdaId}
        />
        <TextField
          type="hidden"
          name="sectionId"
          value={sectionId}
        />
        <Grid
          container
          component="main"
          className={classes.root}
        >
          <Typography
            className={classes.title}
            variant="h5"
          >
            <Tooltip title="Back">
              <IconButton
                onClick={() => window.location.replace('#/dashboard/graded-discussion-reports')}
                size="large">
                <ArrowBackIcon fontSize="small" color="primary" />
              </IconButton>
            </Tooltip>
            {sectionLabel}, {courseLabel}
          </Typography>
          <Grid
            container
            spacing={2}
            style={{
              marginLeft: 5,
              marginRight: 10,
            }}
          >
            <Grid item xs={12} sm={6} style={{ display: 'flex', flexDirection: 'row' }}>
              <Typography
                variant="subtitle1"
                color="primary"
                style={{
                  marginRight: '1%',
                  fontSize: 16

                }}
              >
                Start Date:
          </Typography>
              <Typography
                variant="subtitle1"
                style={{
                  marginLeft: 17,
                  fontSize: 16

                }}
              >
                {gdaStartDate}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} style={{ display: 'flex', flexDirection: 'row' }}>
              <Typography
                variant="subtitle1"
                color="primary"
                style={{
                  fontSize: 16

                }}
              >
                End Date:
          </Typography>
              <Typography
                variant="subtitle1"
                style={{
                  marginLeft: '5%',
                  fontSize: 16

                }}
              >
                {gdaDdueDate}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} style={{ display: 'flex', flexDirection: 'row' }}>
              <Typography
                variant="subtitle1"
                color="primary"
                style={{
                  marginRight: '1%',
                  fontSize: 16

                }}
              >
                Topic:
          </Typography>
              <Typography
                variant="subtitle1"
                style={{
                  marginLeft: 52,
                  fontSize: 16,
                  textTransform: 'capitalize'
                }}
              >
                {gdaLabel}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} style={{ display: 'flex', flexDirection: 'row' }}>
              <Typography
                variant="subtitle1"
                color="primary"
                style={{
                  marginRight: '1%',
                  fontSize: 16

                }}
              >
                Total Marks:
          </Typography>
              <Typography
                variant="subtitle1"
                style={{
                  marginLeft: '2%',
                  fontSize: 16

                }}
              >
                {obtainedMarks ? `${obtainedMarks} /` : ''}  {gdaTotalMarks}
              </Typography>
            </Grid>
            <Grid item xs={12} style={{ display: 'flex', flexDirection: 'column' }}>
              <Typography
                variant="subtitle1"
                color="primary"
                style={{
                  marginRight: '1%',
                  fontSize: 16

                }}
              >
                Instructions:
          </Typography>
              <TextField
                fullWidth
                variant="outlined"
                multiline
                rows={3}
                focused={false}
                InputProps={{
                  style: {
                    textTransform: 'capitalize',
                    cursor: 'default'
                  }
                }}
                value={gdaInstruction}
                inputProps={{
                  readOnly: true,
                }}

              />
            </Grid>
            <Grid size={12}>
              <Typography
                variant="subtitle1"
                color="primary"
                style={{
                  marginRight: '1%',
                  fontSize: 16

                }}
              >
                Message
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                multiline
                rows={6}
                placeholder="Write a Message"
                name="discussionEssay"
                id="discussionEssay"
                focused={!dueCheck}
                value={discussionEssay}
                error={discussionEssayError}
                helperText={discussionEssayError}
                onChange={!dueCheck ? (e) => onHandleChange(e) : ''}
                inputProps={{
                  readOnly: dueCheck,
                }}
              />
            </Grid>
          </Grid>
          <br />
        </Grid>
        <input type="submit" id="gradedDiscussionStudentSubmit" style={{ display: 'none' }} />
      </form>
      <Typography
        className={classes.title}
        variant="h5"
        style={{
          marginLeft: 30,
          marginRight: 30,
          width: '96%',
          paddingBottom: 10
        }}
      >
        Other Student&apos;s Messages
          </Typography>
      {commentLoading ? <center> <CircularProgress style={{ margin: 20 }} /> </center> :
        commentsData.length > 0 ?
          commentsData.map(item => {
            const name = `${item.studentName || ""}`
            const firstChar = name ? name.charAt(0) : '?';
            return (
              <Fragment key={item.id}>
                <CommentCard title={<span style={{ textTransform: 'capitalize' }}>{name}</span>} subTitle={item.createdOn} content={
                  <Typography style={{
                    marginLeft: 8,
                    marginTop: '-10px',
                    fontSize: 16,
                    fontWeight: 600
                  }} variant="body2" color="textSecondary" component="p"> {item.discussionEssay} </Typography>
                } avatarCharacter={firstChar.toLocaleUpperCase()} cardStyle={{ marginLeft: 30, marginRight: 30, marginBottom: 30 }} />
              </Fragment>
            )
          }) : <center> <span>No Found</span></center>}
      <BottomBar
              left_button_text="View"
              leftButtonHide={true}
              bottomLeftButtonAction={viewReport}
              right_button_text="Save"
              rightButtonDisable={!discussionEssay || gdaId != 0}
              rightButtonAction={clickOnFormSubmit}
              loading={isLoading}
          />
    </Fragment>
  );
};

GradedDiscussionForm.propTypes = {
  isDrawerOpen: PropTypes.bool,
  setDrawerOpen: PropTypes.func
}

GradedDiscussionForm.defaultProps = {
  isDrawerOpen: true,
  setDrawerOpen: fn => fn,
  match: {
    params: {
      gdaId: 0
    }
  }
}

export default GradedDiscussionForm;
